import { render, staticRenderFns } from "./JobCard.vue?vue&type=template&id=64762610"
import script from "./JobCard.vue?vue&type=script&lang=ts"
export * from "./JobCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports